module.exports = __webpack_public_path__ + "media/student_lending_center/02-e023c7f9.png";